import { Component, Input, OnInit } from '@angular/core';
// import { MatCarousel, MatCarouselComponent } from '@ngmodule/material-carousel';
import { MxSlider } from '../mx-slider.service';
import { Router } from '@angular/router';
import { MxSlide, MxSliderConfig } from '../mx-slider.model';

@Component({
  selector: 'mx-slider',
  templateUrl: './mx-slider.component.html',
  styleUrls: ['./mx-slider.component.scss']
})
export class MxSliderComponent implements OnInit {
  sliderConfig: MxSliderConfig

  @Input() slides: MxSlide[] = [];
  @Input() slidesCollection: string = ''

  constructor (
    public _slider: MxSlider,
    private router: Router
  ) {
    this.sliderConfig = this._slider.sliderConfig
   }


  async ngOnInit() {
    this._slider.loadConfiguration(this.slidesCollection)
      .subscribe( config => {
        this.sliderConfig = config
      } )
    if (this.slides.length > 0)
      this.slides = await this._slider.loadSlides( this.slidesCollection )
  }


}
